/*
 * Resource request pop-up (sections/co-resources.liquid).
 *
 * Each item in the resources list is a link that names a <dialog>. A click
 * opens it with the item's title, and the form inside posts a name and an
 * email through the contact form, so the request reaches the studio by email.
 * After the post Shopify reloads the page; the dialog then carries the
 * confirmation (or the errors) and is opened again to show it.
 *
 * Only decorates: without this script, or without <dialog>, the items stay
 * the ordinary links they are rendered as. Delegated from the document so
 * sections re-rendered by the theme editor keep working.
 */
(function () {
  'use strict';

  var LINK = '[data-resource-request]';
  var DIALOG = 'dialog.co__request';
  var FLAG = 'nb:b2b-resource-request';
  var SENDING = 'co__request--sending';

  if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;

  function open(dialog, title) {
    if (title !== undefined) {
      var name = dialog.querySelector('[data-resource-name]');
      var input = dialog.querySelector('[data-resource-input]');
      if (name) name.textContent = title;
      if (input) input.value = title;
    }

    // <body> is the one parent no section can clip or restack, which matters
    // once the dialog leaves the top layer (see the submit handler).
    if (dialog.parentNode !== document.body) document.body.appendChild(dialog);

    if (dialog.classList.contains(SENDING)) {
      dialog.classList.remove(SENDING);
      dialog.close();
    }
    if (!dialog.open) dialog.showModal();

    // The first empty field, so a returning error does not land on a filled one.
    var field = Array.prototype.filter.call(
      dialog.querySelectorAll('input:not([type="hidden"])'),
      function (el) { return !el.value; }
    )[0];
    if (field) field.focus();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(LINK);
    if (link) {
      var dialog = document.getElementById(link.getAttribute('data-resource-request'));
      if (!dialog) return;

      event.preventDefault();
      open(dialog, link.getAttribute('data-resource-title') || '');
      return;
    }

    var close = event.target.closest('[data-resource-close]');
    if (close) {
      var owner = close.closest(DIALOG);
      if (owner) owner.close();
      return;
    }

    // A click on the dialog element itself is a click on its backdrop: the
    // form fills the box, so anything inside it has a different target.
    if (event.target.matches && event.target.matches(DIALOG)) event.target.close();
  });

  // The flag tells the confirmation it follows a real submit (a reload of the
  // success URL is not a second lead), and it carries the item's title across
  // the reload in case the form comes back with errors.
  document.addEventListener('submit', function (event) {
    var dialog = event.target.closest(DIALOG);
    if (!dialog) return;

    var input = dialog.querySelector('[data-resource-input]');
    try { sessionStorage.setItem(FLAG, (input && input.value) || '1'); } catch (err) {}

    // Shopify's captcha takes the submit from here, and when it has to ask the
    // visitor something it does so in a box of its own on <body>. A modal
    // dialog is in the top layer, above that box, and makes the rest of the
    // page inert, so the question could be neither seen nor answered. The
    // dialog therefore steps down to an ordinary fixed box (styled by the
    // class) until the page reloads with the answer.
    if (!dialog.classList.contains(SENDING)) {
      dialog.close();
      dialog.classList.add(SENDING);
      dialog.show();
    }
  });

  // Back from the post: show what the form has to say.
  function showResult() {
    var dialogs = document.querySelectorAll(DIALOG);

    for (var i = 0; i < dialogs.length; i++) {
      var state = dialogs[i].querySelector('[data-resource-state]');
      if (!state) continue;

      var title;
      if (state.getAttribute('data-resource-state') === 'error') {
        try { title = sessionStorage.getItem(FLAG) || undefined; } catch (err) {}
        if (title === '1') title = undefined;
      }

      var section = dialogs[i].closest('.co');
      if (section) section.scrollIntoView({ block: 'center' });
      open(dialogs[i], title);
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showResult);
  } else {
    showResult();
  }
})();
